<ion-list-header class="freebet-total-header">
  <ion-item class="background-color-transparent">
    <h1><img src="assets/global/img/freebet-black.png" /></h1>
  </ion-item>
</ion-list-header>

<div class="free-bet-total">
  <ion-item class="item">
    {{'fbtotal' | translate }}&nbsp;<b>{{'fbpendient' | translate}}</b>:&nbsp;<span class="colorPending"
      >{{aPendingFBLength()}}</span
    >
  </ion-item>
  <!-- <hr /> -->
  <ion-item class="item">
    {{'fbtotal' | translate }}&nbsp;<b>{{'fbdisponib' | translate}}</b>:&nbsp;<span class="colorAvalaible"
      >{{activeFBLength()}}</span
    >
  </ion-item>
</div>
